import { useReducer } from "react";
import orderByReducer from "./orderByReducer";
import orderByContext from "./orderByContext";

export default function OrderByState({ children }) {

    const initialState = {
        orderBy: "recommended"
    };

    const [state, dispatch] = useReducer(orderByReducer, initialState);

    const setOrderBy = (orderBy) => {
        dispatch({ type: "SET_ORDER_BY", payload: orderBy });
    };

    return (
        <orderByContext.Provider value={{ state, setOrderBy }}>
            {children}
        </orderByContext.Provider>
    );
}
